import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as FeatureFlagsSelectors from './feature-flags.selectors';
import { FeatureFlags } from '../../core/models/feature-flags.model';

/** Facade for accessing feature flags state from components */
@Injectable({ providedIn: 'root' })
export class FeatureFlagsFacade {
  private readonly store = inject(Store);

  readonly featureFlags$: Observable<FeatureFlags> = this.store.select(
    FeatureFlagsSelectors.selectFeatureFlags
  );

  readonly ready$: Observable<boolean> = this.store.select(
    FeatureFlagsSelectors.selectFeatureFlagsReady
  );

  readonly loading$: Observable<boolean> = this.store.select(
    FeatureFlagsSelectors.selectFeatureFlagsLoading
  );

  readonly error$: Observable<string | null> = this.store.select(
    FeatureFlagsSelectors.selectFeatureFlagsError
  );

  readonly useV2ApiForAutomation$: Observable<boolean> = this.store.select(
    FeatureFlagsSelectors.selectUseV2ApiForAutomation
  );

  readonly enableDiagnosticPageAccess$: Observable<boolean> = this.store.select(
    FeatureFlagsSelectors.selectEnableDiagnosticPageAccess
  );

  /**
   * Get boolean flag value by domain and property path
   * All feature flags are boolean-only (ON/OFF toggles)
   * @param domain - Feature flag domain (e.g., 'payroll', 'forms')
   * @param property - Property name within domain
   * @returns Observable<boolean | undefined> - boolean if flag exists, undefined if not found
   */
  getFlagByPath(
    domain: keyof FeatureFlags,
    property: string
  ): Observable<boolean | undefined> {
    return this.store.select(
      FeatureFlagsSelectors.selectFlagByPath(String(domain), property)
    );
  }
}
